<template>
  <div class="collage-carousel">
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item"
        :class="{ visible: imageVisible[index] }"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
        >
        
        <!-- Estrellas en las 4 esquinas -->
        <!-- Se usa v-if o simplemente se cargan; asegúrate que la ruta sea correcta -->
        <img src="@/assets/es.png" class="star-corner top-left" alt="estrella">
        <img src="@/assets/es.png" class="star-corner top-right" alt="estrella">
        <img src="@/assets/es.png" class="star-corner bottom-left" alt="estrella">
        <img src="@/assets/es.png" class="star-corner bottom-right" alt="estrella">
      </div>
    </div>

    <!-- Modal -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
      >
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimado',
  setup() {
    const images = [

      
      require('@/assets/FOTO6(1).webp'),
    ]

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    const collageItems = ref([])
    const imageVisible = ref(new Array(images.length).fill(false))

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    const observeImages = () => {
      const options = { threshold: 0.2 }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = collageItems.value.indexOf(entry.target)
          if (entry.isIntersecting) {
            imageVisible.value[index] = true
            animateIn(entry.target, index)
          }
        })
      }, options)

      collageItems.value.forEach((el) => observer.observe(el))
    }

    const animateIn = (el, index) => {
      const animations = [
        { from: { opacity: 0, y: 80 }, to: { opacity: 1, y: 0 } },
        { from: { opacity: 0, x: -80 }, to: { opacity: 1, x: 0 } },
        { from: { scale: 0.8, opacity: 0 }, to: { scale: 1, opacity: 1 } },
        { from: { rotate: 15, opacity: 0 }, to: { rotate: 0, opacity: 1 } },
        { from: { x: 60, scale: 0.9, opacity: 0 }, to: { x: 0, scale: 1, opacity: 1 } },
      ]
      const type = animations[index % animations.length]

      gsap.fromTo(el, type.from, {
        ...type.to,
        duration: 1.2,
        ease: 'power3.out'
      })
    }

    onMounted(async () => {
      await nextTick()
      collageItems.value = collageItems.value.slice(0, images.length)
      observeImages()
    })

    return {
      images,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal,
      collageItems,
      imageVisible,
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
}

.collage-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0;
}

.collage-item {
  position: relative;
  grid-column: span 12;
  opacity: 0;
  cursor: pointer;
  transition: transform 0.3s ease;
  /* Importante: quitamos overflow hidden para que las estrellas se vean si sobresalen */
  overflow: visible; 
}

.collage-item.visible {
  opacity: 1;
}

.collage-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.collage-item:hover .collage-image {
  transform: scale(1.02);
}

/* --- AJUSTE DE ESTRELLAS --- */
.star-corner {
  position: absolute;
  width: 120px; /* Reduje el tamaño; 140px era gigante y podía quedar fuera de vista */
  height: auto;
  pointer-events: none;
  z-index: 10;
  /* Opacidad inicial en 0.8 para que se vean sin hover, cambia a 1 en hover */
  opacity: 0.8; 
  transition: opacity 0.4s ease, transform 0.3s ease;
  animation: starTwinkle 2s infinite ease-in-out;
}

.collage-item:hover .star-corner {
  opacity: 1;
}

/* Posicionamiento en las meras orillas */
.top-left { top: -10px; left: -30px; }
.top-right { top: -10px; right: -30px; }
.bottom-left { bottom: -10px; left: -50; opacity: 0; }
.bottom-right { bottom: -10px; right: -30; opacity: 0; }

@keyframes starTwinkle {
  0%, 100% { transform: scale(1); filter: drop-shadow(0 0 5px rgb(255, 255, 252)); }
  50% { transform: scale(1.2); filter: drop-shadow(0 0 15px rgb(255, 255, 255)); }
}

/* Modal */
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 10, 10, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
  object-fit: contain;
}
</style>